import React, { useState, useEffect } from 'react';
import { Flex, Divider, Button } from 'antd';
import caricon from '../../../images/car-icon.svg';
import useLineLiff from 'hooks/LineLiff';
import Header from 'pages/booking/components/Header';
import { decodeBase64Object, encodeBase64Object } from 'shared/common';

import '../../booking/booking.scss';

const Event = () => {
  const { liff, userInfo } = useLineLiff(process.env.REACT_APP_LIFF_ID_PNP);
  const [pageLoading, setPageLoading] = useState(true);
  const [pnpData, setPnpData] = useState({});

  useEffect(() => {
    if (!userInfo) return;

    const idToken = liff.getIDToken();

    const queryParams = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    // decode base64
    const decodedParams = decodeBase64Object(queryParams);
    setPnpData(decodedParams);

    document.title = `LEXUS | ${
      decodedParams.title || queryParams.get('title')
    }`;

    setPageLoading(false);
  }, [userInfo]);

  const handleAddToCalendar = () => {
    const eventConfig = {
      title: `LEXUS ${pnpData.event || '活動'}`,
      description: [
        `活動名稱: ${pnpData.event || ''}`,
        `報名人數: ${pnpData.applicant || ''}`,
        pnpData.url ? `詳細資訊: ${pnpData.url}` : '',
      ]
        .filter(Boolean)
        .join('\n'),
      location: pnpData.location || '',
      startDate: pnpData.appointed_date,
      startTime: pnpData.appointed_time,
      filename: 'lexus-event.ics',
      categories: ['LEXUS', 'Event', 'Activity'],
      url: pnpData.url || '',
    };

    const buildQueryParams = new URLSearchParams(
      encodeBase64Object({
        title: eventConfig.title,
        description: eventConfig.description,
        location: eventConfig.location,
        startDate: eventConfig.startDate,
        startTime: eventConfig.startTime,
        filename: eventConfig.filename,
        categories: eventConfig.categories.join(','),
        url: eventConfig.url,
      })
    ).toString();

    const fullUrl = `${window.location.origin}/hotai/lexus/pnp/downloadCalendar?${buildQueryParams}`;

    liff.openWindow({
      url: fullUrl,
      external: true,
    });
  };

  const handleDetailedSchedule = () => {
    if (!pnpData.url) return;

    liff.openWindow({
      url: pnpData.url,
      external: true,
    });
  };

  const handleCancelRegistration = () => {
    // Cancel registration functionality
    console.log('Canceling registration...');
  };

  const renderField = (label, value, showDivider = false) => (
    <>
      <div className="form-content">
        <Flex align="center">
          <span
            className="form-subtitle"
            style={{ width: '140px', minWidth: '140px' }}>
            {label}:
          </span>
          <span
            className="form-subtitle"
            style={{ fontWeight: 'bold', textAlign: 'left' }}>
            {value || '-'}
          </span>
        </Flex>
      </div>
      {showDivider && <Divider style={{ margin: '12px 0' }} />}
    </>
  );

  return (
    <div className="booking-container">
      <Header />
      <div className="form-container">
        <div className="form-section">
          <div
            className="form-content"
            style={{ textAlign: 'center', marginBottom: '24px' }}>
            <Flex align="center" gap="small">
              <img src={caricon} alt="Car icon" />
              <div className="form-title">Lexus {pnpData.title}</div>
            </Flex>
          </div>

          {/* {renderField('姓名', pnpData.customerName)} */}
          {renderField('活動名稱', pnpData.event)}
          {renderField('活動日期', pnpData.appointed_date)}
          {renderField('活動時間', pnpData.appointed_time)}
          {renderField('報名人數', pnpData.applicant)}
        </div>

        <div
          style={{
            marginTop: '24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}>
          <Button
            type="primary"
            size="large"
            onClick={handleAddToCalendar}
            loading={pageLoading}
            style={{
              height: '50px',
              fontSize: '16px',
              fontWeight: 'bold',
              backgroundColor: '#52c41a',
              borderColor: '#52c41a',
              borderRadius: '8px',
            }}>
            加入行事曆
          </Button>

          <Button
            type="default"
            size="large"
            onClick={handleDetailedSchedule}
            loading={pageLoading}
            style={{
              height: '50px',
              fontSize: '16px',
              fontWeight: 'bold',
              borderRadius: '8px',
            }}>
            詳細行程
          </Button>

          {/* <Button
            type="default"
            size="large"
            onClick={handleCancelRegistration}
            style={{
              height: '50px',
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#ff4d4f',
              borderColor: '#ff4d4f',
              borderRadius: '8px',
            }}>
            取消報名
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default Event;
